import React, { useState } from "react";
import { FaSpinner } from "react-icons/fa";
import styles from "./ContactForm.module.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    service: "",
    date: "",
    message: "",
    type: "in-person",
  });
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg({ type: "", text: "" });

    try {
      const res = await fetch(
        "https://muigaimedicalclinic.co.ke/api/submit_appointment.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );
      const data = await res.json();
      if (data.success) {
        setResponseMsg({
          type: "success",
          text: "Appointment booked successfully! We will contact you soon.",
        });
        setFormData({
          name: "",
          phone: "",
          service: "",
          date: "",
          message: "",
          type: "in-person",
        });
      } else {
        setResponseMsg({
          type: "error",
          text: data.message || "Something went wrong.",
        });
      }
    } catch (error) {
      setResponseMsg({
        type: "error",
        text: "Network error. Please try again.",
      });
    }
    setLoading(false);
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      {responseMsg.text && (
        <div
          className={
            responseMsg.type === "success" ? styles.successMsg : styles.errorMsg
          }
        >
          {responseMsg.text}
        </div>
      )}
      <div className={styles.row}>
        <div className={styles.field}>
          <label htmlFor="name">Full Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        <div className={styles.field}>
          <label htmlFor="phone">Phone Number *</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            required
            value={formData.phone}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.field}>
          <label htmlFor="service">Service Needed *</label>
          <select
            id="service"
            name="service"
            required
            value={formData.service}
            onChange={handleChange}
          >
            <option value="">Select a service</option>
            <option>General Consultation</option>
            <option>Specialist Appointment</option>
            <option>Diagnostic Imaging</option>
            <option>Laboratory Test</option>
            <option>Minor Surgical Procedure</option>
            <option>Rehabilitation & Counseling</option>
            <option>Vaccination</option>
            <option>Health Check-up & Screening</option>
          </select>
        </div>
        <div className={styles.field}>
          <label htmlFor="date">Preferred Date *</label>
          <input
            type="date"
            id="date"
            name="date"
            required
            value={formData.date}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className={styles.field}>
        <label htmlFor="type">Consultation Type</label>
        <div className={styles.radioGroup}>
          <label>
            <input
              type="radio"
              name="type"
              value="in-person"
              checked={formData.type === "in-person"}
              onChange={handleChange}
            />
            In-Person
          </label>
          <label>
            <input
              type="radio"
              name="type"
              value="teleconsultation"
              checked={formData.type === "teleconsultation"}
              onChange={handleChange}
            />
            Teleconsultation (WhatsApp/Phone)
          </label>
        </div>
      </div>
      <div className={styles.field}>
        <label htmlFor="message">Additional Message (Optional)</label>
        <textarea
          id="message"
          name="message"
          rows="4"
          value={formData.message}
          onChange={handleChange}
        ></textarea>
      </div>
      <button type="submit" className={styles.submitBtn} disabled={loading}>
        {loading ? (
          <>
            <FaSpinner className={styles.spinner} /> Booking...
          </>
        ) : (
          "Book Appointment"
        )}
      </button>
    </form>
  );
};

export default ContactForm;
